import PropTypes from 'prop-types'

import {useSuiContext} from '@s-ui/react-context'
import {useMediaQuery, useMediaQueryBreakpoints} from '@adv-mt/mt-layout-render-media-query'
import SharedBrandLogo from '@adv-mt/mt-shared-brand-logo'
import IconCheckSmall from '@adv-mt/mt-svg-icons/lib/CheckSmall.js'
import {Button, BUTTON_SHAPES, BUTTON_SIZES, BUTTON_VARIANTS} from '@adv-mt/ui/button'
import {Icon, ICON_INTENTS, ICON_SIZES} from '@adv-mt/ui/icon'
import {Body1, Subhead1} from '@adv-mt/ui/typography'

import {BASE_CLASS as PAGE_BASE_CLASS} from '../../../config.js'
import {DRAWER_TYPES} from '../../../drawers/config.js'

const BASE_CLASS = `${PAGE_BASE_CLASS}-noCommissions`

const FEATURE_KEYS = [
  'DETAIL_NO_COMMISSIONS_TRANSPARENT_PURCHASE',
  'DETAIL_NO_COMMISSIONS_SELLER_PRICE',
  'DETAIL_NO_COMMISSIONS_NO_CONTACT_COST'
]

const NoCommissions = ({onOpenDrawer}) => {
  const {domain, i18n} = useSuiContext()
  const siteName = domain.get('config').get('SITE_NAME')

  const isHigherThanMobile = useMediaQuery(useMediaQueryBreakpoints.sm, {
    defaultMatches: !domain.get('config').get('isMobile')
  })

  const handleShowMore = () => {
    onOpenDrawer({type: DRAWER_TYPES.NO_COMMISSIONS})
  }

  return (
    <div className={BASE_CLASS}>
      <div className={`${BASE_CLASS}-header`}>
        <Subhead1 as="h3">{i18n.t('COMMON.DETAIL_NO_COMMISSIONS', {siteName})}</Subhead1>
      </div>

      <div className={`${BASE_CLASS}-logo`}>
        <SharedBrandLogo alt="" />
      </div>

      <ul className={`${BASE_CLASS}-list`}>
        {FEATURE_KEYS.map(key => (
          <li className={`${BASE_CLASS}-item`} key={key}>
            <Icon size={ICON_SIZES.MD} intent={ICON_INTENTS.PRIMARY}>
              <IconCheckSmall size={ICON_SIZES.MD} />
            </Icon>
            <Body1>{i18n.t(`COMMON.${key}`)}</Body1>
          </li>
        ))}
      </ul>

      <div className={`${BASE_CLASS}-actions`}>
        <Button
          onClick={handleShowMore}
          shape={BUTTON_SHAPES.CIRCLE}
          size={isHigherThanMobile ? BUTTON_SIZES.MEDIUM : BUTTON_SIZES.LARGE}
          variant={BUTTON_VARIANTS.OUTLINE}
        >
          {i18n.t('COMMON.DETAIL_NO_COMMISSIONS_LEARN_MORE')}
        </Button>
      </div>
    </div>
  )
}

NoCommissions.displayName = 'NoCommissions'

NoCommissions.propTypes = {
  onOpenDrawer: PropTypes.func.isRequired
}

export default NoCommissions
